import { Box, SimpleGrid, SimpleGridProps, BoxProps } from "@chakra-ui/react";
import EmptyState from "components/EmptyState";

import TinyHeading from "components/TinyHeading";
import { TraitTileProps } from "components/TraitTile";

type TraitsListProps = Omit<BoxProps, "gap" | "children"> &
  Pick<SimpleGridProps, "gap" | "columns"> & {
    title: string;
    children?: (React.ReactElement<TraitTileProps> | null)[];
  };

const TraitsList = ({
  title,
  children,
  columns = 1,
  gap = "2px",
  ...rest
}: TraitsListProps) => (
  <Box bg="dark.400" w="full" color="bright.500" {...rest}>
    <Box py="3" px="4">
      <TinyHeading>{title}</TinyHeading>
    </Box>

    {children?.length ? (
      <SimpleGrid gap={gap} columns={columns}>
        {children}
      </SimpleGrid>
    ) : (
      <EmptyState pt="6" pb="6" opacity="0.8" />
    )}
  </Box>
);

export default TraitsList;
